import { render, staticRenderFns } from "./ActivityDetailModal.vue?vue&type=template&id=52cf4a1f"
import script from "./ActivityDetailModal.vue?vue&type=script&lang=js"
export * from "./ActivityDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports